<section [formGroup]="form" class="form-group" [attr.aria-label]="'base.field.group.branche_field' | transloco">
	<lvr-field [label]="'base.field.branche' | transloco" class="branch-field">
		<mat-form-field lvrInput>
			<input
				matInput
				formControlName="industryName"
				placeholder="Branche"
				[matAutocomplete]="autoCompl"
				(focus)="onInputFocus()"
			/>
			<mat-autocomplete
				#autoCompl="matAutocomplete"
				autoActiveFirstOption
				[displayWith]="displayBranch"
				(optionSelected)="branchSelected($event)"
			>
				@for (option of suggestions(); track option) {
					<mat-option [value]="option">
						{{ option }}
					</mat-option>
				}
				@if (suggestions().length === 0) {
					<mat-option disabled>
						{{ 'base.form.warning.no_branche_suggestion' | transloco }}
					</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
	</lvr-field>
</section>
